import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { Observable } from 'rxjs';
import { CompanyDetailsGeneratedContentSettingsDto, TryMeAiContentSettingsPayloadDto } from '../../dto';

@Injectable({
    providedIn: 'root'
})
export class AiGeneratedContentSettingsApiService {
    private readonly url: string = 'service/contactcloud/aicontentsettings';

    constructor(private readonly baseApiService: BaseApiService) { }

    updateAiContentSettings(companyDetails: CompanyDetailsGeneratedContentSettingsDto): Observable<{response: string}> {
        return this.baseApiService.put(this.url, companyDetails);
    }

    getAiContentSettings(): Observable<CompanyDetailsGeneratedContentSettingsDto> {
        return this.baseApiService.get(this.url);
    }

    tryMeAiContentSettings(tryPayload: TryMeAiContentSettingsPayloadDto): Observable<{content: string}> {
        return this.baseApiService.post('service/contactcloud/contentset/tryme', tryPayload);
    }

}
